import { call, put } from 'redux-saga/effects';
import { DELETE, getHeaders } from 'src/services/ApiService';
import { fetchProducts, onDeleteProductFailure, onDeleteProductSuccess } from '../slice';

export function* deleteProductInstance(action) {
    const { deleteClientId } = action.payload;
    const result = yield call(DELETE, `/clients/${deleteClientId}`, getHeaders());
    if (result.isSuccess) {
        yield put(onDeleteProductSuccess(result.response));
        yield put(fetchProducts());
    } else {
        // const error = formatMessage(Locale.productInstanceDeletedFailed);
        yield put(onDeleteProductFailure(result));
    }
}
